<div [innerHTML]="text" class="answer">
</div>
<div [ngClass]="{'disable': disabled}" class="star-rating">
  <span *ngFor="let _ of stars; let i = index" class="star" (click)="onStarClick(i + 1)">
    {{ i + 1 <= value ? '&#9733;' : '&#9734;' }} </span>
</div>
<input class="comment-input" [disabled]="disabled" type="text" placeholder="Add comment here(optional)"
  [(ngModel)]="comment" (input)="OnInputChange()" />